import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3000/',
  baseURL: 'https://vials-api.nirnayanhealthcare.com/',
});

export default api;